import React from "react";
import { Gift, Check, RotateCcw, Phone, Sparkles } from "lucide-react";

const rise = (i = 0) => ({ animation: `azRise 6s ${(i * 0.45).toFixed(2)}s ease-in-out infinite` });

const Frame = ({ title, children }) => (
  <div className="rounded-2xl border border-border bg-card shadow-xl overflow-hidden">
    <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-border bg-muted/40">
      <span className="h-2.5 w-2.5 rounded-full bg-red-400" /><span className="h-2.5 w-2.5 rounded-full bg-amber-400" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
      <span className="ml-3 text-xs text-muted-foreground font-medium">{title}</span>
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export const PackagesShot = () => (
  <Frame title="Online booking — Bundles & Bribes">
    <div className="rounded-xl border border-border overflow-hidden text-sm">
      <div className="p-3 space-y-2">
        <div className="flex items-start justify-between" style={rise(0)}><span className="font-heading font-extrabold uppercase tracking-tight">6 Full Body Plan</span><span className="text-xs text-muted-foreground">total value <b className="text-foreground">$2,230</b></span></div>
        <div className="grid grid-cols-2 gap-2 text-xs" style={rise(1)}>
          <div><div className="text-[9px] uppercase tracking-wider text-muted-foreground">Bundle</div>6 × Full body laser<div className="text-muted-foreground line-through">$2,100 value</div></div>
          <div><div className="text-[9px] uppercase tracking-wider text-muted-foreground">Bribes</div>{["SPF 50 — $40", "After serum — $90"].map((b) => <div key={b} className="flex items-center gap-1"><Gift className="h-3 w-3 text-primary" />{b}</div>)}</div>
        </div>
      </div>
      <div className="bg-primary/5 border-t border-primary/20 p-3 flex items-end justify-between" style={rise(2)}>
        <div><div className="text-[9px] uppercase tracking-wider text-muted-foreground">Pay</div><div className="font-heading font-extrabold text-2xl">$1,800</div></div>
        <div className="text-right text-primary font-bold text-sm flex items-center gap-1"><Sparkles className="h-3.5 w-3.5" />$430 in extra value</div>
      </div>
    </div>
    <div className="mt-3 flex items-center justify-between rounded-lg border border-border p-2.5 text-xs" style={rise(3)}>
      <span>Session 3 of 6 · <span className="text-muted-foreground">redeemed at checkout</span></span><span className="font-semibold text-primary">Use package session →</span>
    </div>
    <div className="mt-2 flex items-center gap-2 rounded-lg bg-muted/60 p-2.5 text-xs" style={rise(4)} data-testid="packages-shot-rename">
      <span className="text-muted-foreground shrink-0">Tab name</span>
      <span className="line-through text-muted-foreground">Bundles & Bribes</span><span className="text-muted-foreground">→</span>
      <span className="font-semibold px-2 py-0.5 rounded-full bg-primary/10 text-primary">Glow Club</span>
      <span className="ml-auto text-[10px] text-muted-foreground hidden sm:inline">your brand, your voice</span>
    </div>
  </Frame>
);

export const DepositShot = () => (
  <Frame title="Online booking — deposit">
    <div className="text-sm space-y-2">
      <div className="flex justify-between" style={rise(0)}><span>Full body laser · Thu 2:00pm</span><span className="tabular-nums">$350</span></div>
      <div className="flex justify-between text-muted-foreground text-xs" style={rise(1)}><span>Deposit to secure</span><span className="tabular-nums">$50</span></div>
      <div className="grid grid-cols-2 gap-2 pt-1" style={rise(2)}>
        <div className="h-10 rounded-lg bg-primary text-primary-foreground text-xs font-semibold flex items-center justify-center">Pay deposit now</div>
        <div className="h-10 rounded-lg border border-border text-xs font-medium flex items-center justify-center text-center leading-tight">Pay later — we'll text a link</div>
      </div>
      <div className="flex items-center gap-2 pt-1" style={rise(3)}>
        <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">Deposit unpaid</span>
        <span className="text-xs text-muted-foreground">shows on the diary until it's paid</span>
      </div>
    </div>
  </Frame>
);

export const AppointmentPayShot = () => (
  <Frame title="Appointment — payment">
    <div className="text-sm space-y-1.5">
      {[["Hydrafacial", "$180.00"], ["Deposit applied", "−$50.00"], ["Azordi Terminal · Visa •••• 4242", "$130.00"]].map(([l, v], i) => (
        <div key={l} style={rise(i)} className="flex justify-between"><span className={i > 0 ? "text-muted-foreground" : ""}>{l}</span><span className="tabular-nums">{v}</span></div>
      ))}
      <div className="border-t border-border my-1.5" />
      <div className="flex gap-2" style={rise(3)}>
        <span className="flex-1 h-9 rounded-lg border border-border text-xs font-medium flex items-center justify-center gap-1"><RotateCcw className="h-3 w-3" />Refund</span>
        <span className="flex-1 h-9 rounded-lg border border-border text-xs font-medium flex items-center justify-center">Adjust payment</span>
      </div>
      <div className="rounded-lg bg-muted/60 p-2.5 text-xs mt-1" style={rise(4)}>
        <div className="font-medium mb-1">Cancel — reason</div>
        <div className="flex flex-wrap gap-1">{["Client cancelled", "No longer needed", "Mistake · no text sent"].map((r, i) => <span key={r} className={`px-2 py-0.5 rounded-full border ${i === 2 ? "border-primary text-primary" : "border-border text-muted-foreground"}`}>{r}</span>)}</div>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground pt-1" style={rise(5)}><Phone className="h-3 w-3" />Find any appointment by phone number</div>
    </div>
  </Frame>
);

export const CapacityShot = () => (
  <Frame title="Dashboard — September">
    <div className="grid grid-cols-2 gap-2 text-sm">
      {[["This week", 74], ["This month", 61]].map(([l, p], i) => (
        <div key={l} className="rounded-xl border border-border p-3" style={rise(i)}>
          <div className="text-[9px] uppercase tracking-wider text-muted-foreground">{l}</div>
          <div className="font-heading font-extrabold text-2xl">{p}% <span className="text-xs font-medium text-muted-foreground">booked</span></div>
          <div className="h-1.5 rounded-full bg-muted mt-2 overflow-hidden"><div className="h-full bg-primary origin-left" style={{ width: `${p}%`, animation: "azBar 6s ease-in-out infinite" }} /></div>
        </div>
      ))}
    </div>
    <div className="mt-3 rounded-xl border border-border p-3" style={rise(2)}>
      <div className="flex items-center justify-between text-xs text-muted-foreground"><span>‹ Aug</span><span className="font-medium text-foreground">Sales (month)</span><span>Oct ›</span></div>
      <div className="font-heading font-extrabold text-2xl mt-1">$41,280</div>
      <div className="text-xs text-primary flex items-center gap-1"><Check className="h-3 w-3" />Expected to finish at $52,900</div>
    </div>
  </Frame>
);
